export default "__VITE_ASSET__Bfg1qIC7__"